import * as types from '../actions/action-types';
import _ from 'lodash';

const initialState = {
  courses: undefined,

};

const courseReducer = function(state = initialState, action) {

  switch(action.type) {

    case types.GET_MYCOURSES_SUCCESS:
      return Object.assign({}, state, { courses: action.courses });


  }

  return state;

}

export default courseReducer;



/** WEBPACK FOOTER **
 ** ./src/client/app/reducers/course-reducer.js
 **/